import { render, staticRenderFns } from "./Canceledsessiondetail.vue?vue&type=template&id=a06d2326&"
import script from "./Canceledsessiondetail.vue?vue&type=script&lang=js&"
export * from "./Canceledsessiondetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports